import React from 'react';
import { WithTranslationsProps, withTranslations } from 'react-utilities';
import { Modal } from 'react-style-guide';
import { TGameData, TGetGameDetails, TGetFriendsResponse } from '../types/bedev1Types';
import parsingUtils from '../utils/parsingUtils';
import PlayerInteractionModal from '../../../../js/react/gamePlayers/containers/PlayerInteractionModal';
import placesListTranslationConfig from '../../../../js/react/realTimePlaceLists/translation.config';
import '../../../../css/common/_gameTiles.scss';

export type TOnTileClick = (gameData: TGameData, id: number) => void;
export type TGameTileProps = {
  id: number;
  translate: WithTranslationsProps['translate'];
  onTileClick: TOnTileClick;
  gameData: TGameData;
};

export const GameTileStats = ({
  totalDownVotes,
  totalUpVotes,
  playerCount
}: {
  totalUpVotes: number;
  totalDownVotes: number;
  playerCount: number;
}): JSX.Element => {
  const votes = parsingUtils.getVotePercentage(totalUpVotes, totalDownVotes);
  const players = parsingUtils.getAbbreviatedValue(playerCount);
  return (
    <div className='game-card-info'>
      <span className='info-label icon-votes-gray' />
      {!votes ? (
        <span className='info-label no-vote' />
      ) : (
        <span className='info-label vote-percentage-label'>{votes}</span>
      )}
      <span className='info-label icon-playing-counts-gray' />
      <span className='info-label playing-counts-label'>{players}</span>
    </div>
  );
};

type TShimmedPlayerInteractionModalComponentProps = {
  show: boolean;
  onHide: () => void;
  friendsDataInGame: TGetFriendsResponse[];
  game: TGetGameDetails;
};

export const ShimmedPlayerInteractionModalComponent = ({
  show,
  onHide,
  friendsDataInGame,
  game,
  translate
}: TShimmedPlayerInteractionModalComponentProps & WithTranslationsProps): JSX.Element => (
  <Modal show={show} onHide={onHide} size='lg'>
    <PlayerInteractionModal
      friendsData={friendsDataInGame.map(friend => {
        return { ...friend, nameForDisplay: friend.displayName };
      })}
      friendsInGame={friendsDataInGame.map(friend => friend.id)}
      game={game}
      dismissModal={onHide}
      translate={translate}
    />
  </Modal>
);

export const ShimmedPlayerInteractionModal = withTranslations<TShimmedPlayerInteractionModalComponentProps>(
  ShimmedPlayerInteractionModalComponent,
  placesListTranslationConfig
);

export default {
  ShimmedPlayerInteractionModal,
  GameTileStats
};
